import Vue from "vue";
import Vuex from "vuex";

import { getUserData, getDateBySeconds } from "./service.js"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: true,
    appName: 'Campus',
    open_player: false,
    user: {
      loggedIn: false,
      data: null,
      favorites: []
    }
  },
  mutations: {
    setLoggedIn(state, value) {
      state.user.loggedIn = value;
    },
    setUser(state, data) {
      state.user.data = data;
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setFavorites(state, favorites) {
      state.user.favorites = favorites
    },
    togglePlayer(state, open) {
      state.open_player = open
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    user (state) {
      return state.user
    },
    appName (state) {
      return state.appName
    },
    favorites (state) {
      return state.user.data.favorites
    },
    open_player (state) {
      return state.open_player
    }
  },
  actions: {
    setFavorites({ commit }, favorites) {
      commit('setFavorites', favorites)
    },
    setUser({ commit }, user_data) {
      commit('setUser', user_data)
    },
    togglePlayer({ commit }, open) {
      commit('togglePlayer', open)
    },
    fetchUser({ commit }, user) {
      return new Promise((resolve) => {
        commit('setLoggedIn', user !== null)
        if (user) {
          getUserData().then(user_result => {
            user_result.plan.get().then(plan_result => {
              let plan = plan_result.data()
              plan.id = plan_result.id
              let user_data = {
                admin: user_result.admin,
                active: user_result.active,
                displayName: user_result.name,
                email: user.email,
                plan: plan,
                premium:  user_result.premium ? true : false,
                covered: null,
                affiliation: {
                  label: getDateBySeconds(user_result.affiliation_date),
                  date: user_result.affiliation_date
                }
              }
              commit('setUser', user_data)
              commit('setLoading', false)
              resolve(user_data)
            })
          })
        } else {
          commit('setUser', null)
          commit('setLoading', false)
          resolve(null)
        }
      })
    }
  },
  modules: {}
});
